// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__dTBk2","filesListContainer":"PosDisputesFiles_filesListContainer__1O-QZ","filesButton":"PosDisputesFiles_filesButton__1rCnh"};